import { VideoWrapper } from "views/home/HomeStyle";
import ModalWrapper from "./ModalWrapper";
import closeIcon from "assets/icons/close.svg";
import { useContext } from "react";
import { TutorialContext } from "contexts/TutorialContext";

/**
 *
 * @param {Object} props
 * @param {Object|null} [props.videoData]
 * @param {Function} [props.closeModal]
 * @param {Function} [props.handleCloseModal]
 * @returns
 */

const TutorialVideoModal = ({ videoData, closeModal }) => {
  const { video, handleCloseVideoModal } = useContext(TutorialContext);

  return (
    <VideoWrapper className={`flexRow justifyEnd show`}>
      <ModalWrapper>
        <div className="modal">
          <button
            type="button"
            className="close_btn flexRow alignCenter justifyCenter"
            onClick={closeModal ?? handleCloseVideoModal}
          >
            <img src={closeIcon} alt="close" />
          </button>
          <iframe
            title={videoData?.type || video.type}
            src={videoData?.desktop_video || video.desktop_video}
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
            width="100%"
            height="100%"
          ></iframe>

          {/* <video
            src={video?.desktop_video}
            className="intro_vid"
            id="introVideo"
            controls
            autoPlay
          /> */}
        </div>
      </ModalWrapper>
    </VideoWrapper>
  );
};

export default TutorialVideoModal;
